export const handleMouseDown =
  (onContinue: () => void) => (event: React.MouseEvent) => {
    if (event.button === 0) {
      event.preventDefault();
      onContinue();
    }
  };
